
// 插件路由
const auction = () => import(/* webpackChunkName: "auction" */ '~/addon/auction/pages/auction.vue')

const routes = [
	{ 
        path: '/auction',
        component: auction
    },
]

export default routes;



// WEBPACK FOOTER //
// ./src/addon/auction/router/index.js